import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';

import WarehouseForm from "./WarehouseForm";
import { withStyles, Dialog } from "@material-ui/core";
import * as Yup from "yup";

import { parseURL } from "../../sc-utilities";
import * as actions from './store/warehouseActions';
import History from "../../../History";
import { hasPermission } from "../../sc-utilities";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const WarehouseEdit = props => {
    const { classes, loading, activeCustomer, translations, loadWarehouseInit, onEditWarehouse, loadWarehouse, warehouse, permissions } = props;
    const [editData, setEditData] = useState({ loadingData: true });

    useEffect(() => {
        const fetchData = async () => {
            await loadWarehouse({ ActiveCustomerID: activeCustomer, WarehouseID: parseURL(window.location.href).warehouseID })
        }
        fetchData();
        return () => {
            loadWarehouseInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (warehouse && Object.keys(warehouse).length > 0) {
            setEditData({ loadingData: false });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [warehouse]);

    const handleSubmit = async data => {
        let result = await onEditWarehouse({ ...data, ActiveCustomerID: activeCustomer, WarehouseID: parseURL(window.location.href).warehouseID });
        if (result) {
            setEditData({ loadingData: true });
            History.goBack()
        }
    };
    let initialValues = {
        Name: warehouse && warehouse.Name ? warehouse.Name : '',
        Description: warehouse && warehouse.Description ? warehouse.Description : '',
        Location: warehouse && warehouse.Location ? warehouse.Location : '',
        ContactPerson: warehouse && warehouse.ContactPerson ? warehouse.ContactPerson : '',
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Description: Yup.string(),
            Location: Yup.string().required("Required"),
            ContactPerson: Yup.string().required("Required")
        },
        FormTitle: translations["edit_warehouse"] || "Edit warehouse",
        ButtonSubmit: hasPermission(permissions, 'warehouse_save') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return (
        !editData.loadingData ?
            <WarehouseForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                loading={loading}
                translations={translations}
            ></WarehouseForm> :
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={editData.loadingData}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        loading: state.warehouses.warehouse.editing,
        warehouse: state.warehouses.warehouse.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onEditWarehouse: data => dispatch(actions.editWarehouse(data)),
        loadWarehouse: data => dispatch(actions.loadWarehouse(data)),
        loadWarehouseInit: () => dispatch(actions.loadWarehouseInit()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(WarehouseEdit));

/**
 *  Translations
 *      edit_warehouse
 *
 */
